import { useState, useEffect } from 'react';
import { enableGoogleAnalytics, disableGoogleAnalytics } from 'utils/cookieUtils';

const COOKIE_CONSENT_KEY = 'cookie_consent_status';

export type CookieConsentStatus = 'accepted' | 'declined' | 'pending';

export const useCookieConsent = () => {
    const [consentStatus, setConsentStatus] = useState<CookieConsentStatus>('pending');
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        // ローカルストレージから同意状態を取得
        const storedConsent = localStorage.getItem(COOKIE_CONSENT_KEY) as CookieConsentStatus;

        if (storedConsent === 'accepted' || storedConsent === 'declined') {
            setConsentStatus(storedConsent);
            setIsVisible(false);
        } else {
            setIsVisible(import.meta.env.VITE_ENV === 'production');
        }
    }, []);

    const acceptCookies = () => {
        setConsentStatus('accepted');
        setIsVisible(false);
        localStorage.setItem(COOKIE_CONSENT_KEY, 'accepted');

        // Google Analyticsを有効化
        enableGoogleAnalytics();
    };

    const declineCookies = () => {
        setConsentStatus('declined');
        setIsVisible(false);
        localStorage.setItem(COOKIE_CONSENT_KEY, 'declined');

        // Google Analyticsを無効化
        disableGoogleAnalytics();
    };

    return {
        consentStatus,
        isVisible,
        acceptCookies,
        declineCookies,
    };
};
